import sha256 from 'js-sha256';
import { exportJsonToExcel, exportJsonToExcelSheet } from '@/utils/vendor/Export2Excel';

export function getStyle(element) {
  if (window.getComputedStyle) {
    return window.getComputedStyle(element, null);
  }
  return element.currentStyle;
}

export function setIconTitle(data) {
  let innerText = '';
  if (localStorage.getItem('lang') === 'cn') {
    innerText = ' - 专业的HR SaaS云平台';
  }
  if (localStorage.getItem('lang') === 'en') {
    innerText = ' - Professional HR SaaS Platform';
  }

  if (!localStorage.getItem('lang')) {
    let lang = 'cn';
    let navLang = navigator.language; // 判断除IE外其他浏览器使用语言
    if (!navLang) {
      // 判断IE浏览器使用语言
      navLang = navigator.browserLanguage;
    }
    if (navLang.toUpperCase() !== 'ZH-CN') {
      lang = 'en';
    }
    localStorage.setItem('lang', lang);
    if (localStorage.getItem('lang') === 'cn') {
      innerText = ' - 专业的HR SaaS云平台';
    }
    if (localStorage.getItem('lang') === 'en') {
      innerText = ' Cloud - Professional HR SaaS Platform';
    }
  }

  document.title = (data.platformName || '2175') + innerText;

  if (data.icon) {
    var link = document.querySelector("link[rel*='icon']");
    if (link) {
      link.href = data.icon;
    } else {
      const addLink = document.createElement('link');
      addLink.href = data.icon;
      document.getElementsByTagName('head')[0].appendChild(addLink);
    }
  }
}

// 获取某元素以浏览器左上角为原点的坐标
export function getPoint(obj, scrollH) {
  // const scrollH = document.getElementsByClassName('luttica-scroll-bar')[0].scrollTop; // 滚动容器 这里用到element-ui的滚动 指定scrollbarBox
  const thisObj = obj;
  let t = obj.offsetTop; // 获取该元素对应父容器的上边距
  let l = obj.offsetLeft; // 对应父容器的上边距
  // 判断是否有父容器，如果存在则累加其边距
  // eslint-disable-next-line
  while (obj = obj.offsetParent) { // 等效 obj = obj.offsetParent;while (obj != undefined)
    t += obj.offsetTop; // 叠加父容器的上边距
    l += obj.offsetLeft; // 叠加父容器的左边距
  }
  thisObj.style.left = `${l}px`;
  thisObj.style.top = `${t - scrollH / 2}px`;
  return {
    left: thisObj.style.left,
    top: thisObj.style.top,
  };
}

export const paramsStringify = (params = {}) => {
  const paramsArray = [];
  let values = '';
  Object.keys(params).forEach(k => {
    switch (typeof params[k]) {
      case 'string':
        values = params[k].trim();
        break;
      case 'undefined':
        values = '';
        break;
      default:
        values = params[k];
        break;
    }
    paramsArray.push(`${k}=${encodeURIComponent(values)}`);
  });
  return paramsArray.join('&');
};
// 动态加载js
export const loadJs = src =>
  new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.onload = () => {
      resolve();
    };
    script.onerror = () => {
      reject();
    };
    script.src = src;
    script.id = 'zhichiScript';
    script.setAttribute('class', 'zhiCustomBtn');
    script.setAttribute('data-args', 'manual=true');
    document.querySelector('body').appendChild(script);
  });

export const selectJsonArray = (array, properties) =>
  array.map(item => {
    const obj = {};
    properties.forEach(prop => {
      obj[prop] = item[prop];
    });
    return obj;
  });

// 下划线转换驼峰
export function lineToHump(name) {
  return name.replace(/(\w)/g, (all, letter) => letter.toUpperCase());
}

// 驼峰转换下划线
export function humpToUnderLine(name) {
  return name.replace(/([A-Z])/g, '_$1').toLowerCase();
}

// 驼峰转换短横线
export const humpToLine = name => name.replace(/([A-Z])/g, '-$1').toLowerCase();

// 首字母大写
export function firstCharUpperCase(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

// 多维数组转一维数组
export function arrChangeOne(arr) {
  return [].concat(
    ...arr.map(item => (Array.isArray(item.children) ? arrChangeOne(item.children) : item))
  );
}

// 多维数组转一维数组2
export function arrChangeOne2(arr, item = []) {
  return [].concat(
    [item],
    ...arr.map(item => (Array.isArray(item.children) ? arrChangeOne2(item.children, item) : item))
  );
}

// 浮点数加法运算
export function FloatAdd(arg1, arg2) {
  let r1;
  let r2;
  let m;
  try {
    r1 = arg1.toString().split('.')[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split('.')[1].length;
  } catch (e) {
    r2 = 0;
  }
  // eslint-disable-next-line
  m = Math.pow(10, Math.max(r1, r2));
  return (arg1 * m + arg2 * m) / m;
}

// 浮点数减法运算
export function FloatSub(arg1, arg2) {
  let r1;
  let r2;
  let m;
  // let n;
  try {
    r1 = arg1.toString().split('.')[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split('.')[1].length;
  } catch (e) {
    r2 = 0;
  }
  // eslint-disable-next-line
  m = Math.pow(10, Math.max(r1, r2));
  // 动态控制精度长度
  // n = (r1 = r2) ? r1 : r2;
  // return ((arg1 * m - arg2 * m) / m).toFixed(n)
  return (arg1 * m - arg2 * m) / m;
}

// 浮点数乘法运算
export function FloatMul(arg1, arg2) {
  let m = 0;
  const s1 = arg1.toString();
  const s2 = arg2.toString();
  try {
    m += s1.split('.')[1].length;
  } catch (e) {
    console.log(e);
  }
  try {
    m += s2.split('.')[1].length;
  } catch (e) {
    console.log(e);
  }
  // eslint-disable-next-line
  return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m);
}

// 浮点数除法运算
export function FloatDiv(arg1, arg2) {
  let t1 = 0;
  let t2 = 0;
  let r1;
  let r2;
  try {
    t1 = arg1.toString().split('.')[1].length;
    // eslint-disable-next-line
  } catch (e) {
  }
  try {
    t2 = arg2.toString().split('.')[1].length;
    // eslint-disable-next-line
  } catch (e) {
  }
  // with (Math) {
  // eslint-disable-next-line
  r1 = Number(arg1.toString().replace('.', ''));
  // eslint-disable-next-line
  r2 = Number(arg2.toString().replace('.', ''));
  // eslint-disable-next-line
  return (r1 / r2) * pow(10, t2 - t1);
}

// header数据格式化
export function formatHeader(arr, obj) {
  // arr 代表需要重置的数组
  // obj 包含的属性及重置的key名
  const newArr = [];
  let keyArr;
  if (obj.type && obj.type === 'selection') {
    // 如果需要多选
    newArr.push({
      type: obj.type,
      key: obj.type,
      align: 'center',
      width: 60,
    });
  }
  if (obj.type && obj.type === 'radio') {
    // 如果需要单选
    newArr.push({
      title: '',
      key: 'action',
      slot: 'action',
      align: 'center',
      width: 40,
      className: 'table-radio-select',
    });
  }
  // 将obj的key提出来
  keyArr = Object.keys(obj);
  // 去除重置属性及type
  keyArr = keyArr.filter(item => item !== 'title' && item !== 'key' && item !== 'type');
  arr.forEach(item => {
    let newObj = {
      title: item[obj.title],
      key: item[obj.key],
      className: item.className,
      renderHeader: item.renderHeader || null,
      render: item.render || null
    };
    // 需要过滤的列
    if (item.filters !== null) {
      newObj.filters = item.filters;
      if (obj.filterRemote) {
        newObj.filterRemote = obj.filterRemote;
      } else {
        newObj.filterMethod = (value, row) => row[item[obj.key]].indexOf(value) > -1;
      }
    }
    // 原属性的添加
    if (keyArr.length !== 0) {
      keyArr.forEach(keys => {
        if (keys === 'slot' || keys === 'filteredValue') {
          if (obj[keys][item[obj.key]]) {
            newObj[keys] = obj[keys][item[obj.key]];
          }
        } else if (keys === 'sortable' && typeof obj[keys] !== 'string') {
          if (obj[keys].notSort.indexOf(item[obj.key]) === -1) {
            newObj[keys] = obj[keys].sort;
          }
          if (obj[keys].sortType) {
            obj[keys].sortType.forEach(item2 => {
              if (item2.key === item[obj.key]) {
                newObj.sortType = item2.order;
              }
            });
          }
        } else if (keys !== 'fixed' && keys !== 'filterRemote') {
          if (item[keys]) newObj[keys] = item[keys];
          else newObj[keys] = obj[keys];
        } else if (item.width) {
          newObj.width = item.width;
        }
      });
    }
    if (item.children) {
      newObj = {
        title: newObj.title,
        align: newObj.align,
        children: formatHeader(item.children, obj),
      };
      // newObj.children.splice(0, 1);
    }
    newArr.push(newObj);
  });
  // 固定的列
  if (obj.fixed) {
    obj.fixed.forEach(fix => {
      newArr.forEach((item, index) => {
        if (fix.type === item.type || fix.type === item.key) {
          newArr[index].fixed = fix.position;
        }
      });
    });
  }
  return newArr;
}

// 获取地址上参数
export function getQueryString(name) {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
  const r = window.location.search.substr(1).match(reg);
  if (r !== null) return unescape(r[2]);
  return null;
}

// 密码加密
export function dataToSha(string) {
  const data = `${string}WjJC40m%5oI!B&K*J^&@a25M9R.com12312.8jS@Wo`;
  return sha256(sha256(data));
}

const formatJson = (filterVal, jsonData) => jsonData.map(v => filterVal.map(j => v[j]));
const getFieldId = (header, arrChild) => {
  let arr = arrChild || [];
  header.forEach(item => {
    if (item.children) {
      arr = arr.concat(getFieldId(item.children));
    } else {
      arr.push(item.field_id);
    }
  });
  return arr;
};

export function exportToExcel(header, list, name, extraHeader, SheetName) {
  let date = new Date(); //获取一个时间对象
  date = '-' + date.getFullYear() + ('0' + (date.getMonth() + 1)).slice(-2) + ('0' + date.getDate()).slice(-2);
  require.ensure([], async () => {
    const tHeader = header.map(item => item.field_name);
    const filterVal = getFieldId(header);
    const data = formatJson(filterVal, list);
    console.log(filterVal)
    console.log(data)
    exportJsonToExcel(tHeader, data, name + date, extraHeader, SheetName);
  });
}

export function exportToExcelSheet(obj, defaultTitle) {
  let dataList = [];
  let date = new Date(); //获取一个时间对象
  date = '-' + date.getFullYear() + ('0' + (date.getMonth() + 1)).slice(-2) + date.getDate();
  obj.forEach(obj => {
    const { header, list, name, extraHeader } = obj;
    const tHeader = header.map(item => item.field_name);
    const filterVal = header.map(item => item.field_id);
    const data = formatJson(filterVal, list);
    dataList.push({ th: tHeader, jsonData: data, title: name, extraHeader: extraHeader });
  });
  exportJsonToExcelSheet(dataList, defaultTitle + date);
}

// 切换到英语修改model-emp样式
export function switchEn(doc, name, length) {
  const modelNames = document.querySelectorAll(doc);
  for (let i = 0; i < modelNames.length; i += 1) {
    modelNames[i].style[name] = length;
  }
}

// 判断手机端还是PC端，返回对应网址
export function phoneOrPc() {
  if (window.location.host.indexOf('cloud') > -1) {
    return window._CONFIG.VUE_APP_H5_URL;
  } else {
    if (window.location.host.indexOf('dev') > -1) {
      return window._CONFIG.VUE_APP_DEV_H5_URL;
    } else return window._CONFIG.VUE_APP_TEST_H5_URL;
  }
}

// 创建隐藏的可下载链接
export function downloadLink(fileName, url) {
  const eleLink = document.createElement('a');
  eleLink.download = fileName;
  eleLink.style.display = 'none';
  eleLink.href = url;
  document.body.appendChild(eleLink);
  eleLink.click();
  document.body.removeChild(eleLink);
}

/**
 * 函数防抖 (只执行最后一次点击)
 * @param fn
 * @param timeout
 * @returns {Function}
 * @constructor
 */
export const Debounce = (fn, timeout = 300) => {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    let ctx = this;
    timer = setTimeout(() => {
      timer = null;
      fn.apply(ctx, args);
    }, timeout);
  };
};
/*

将数字转换成千分位展示

number:传入的数字。必选

places：小数点的位数。可选，默认为两位小数

symbol：数字最后的符号 。可选，默认为美元字符“￥”

thousand：千分位分隔符。可选，默认为“，”

decimal：小数位分隔符。可选，默认为“.”

*/
export function formatMoney(number, places, symbol, thousand, decimal) {
  number = number || 0;
  places = !isNaN((places = Math.abs(places))) ? places : 0;
  symbol = symbol !== undefined ? symbol : '';
  thousand = thousand || ',';
  decimal = decimal || '.';
  var negative = number < 0 ? '-' : '',
    i = parseInt((number = Math.abs(+number || 0).toFixed(places)), 10) + '',
    j = (j = i.length) > 3 ? j % 3 : 0;
  return (
    negative +
    (j ? i.substr(0, j) + thousand : '') +
    i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousand) +
    (places
      ? decimal +
      Math.abs(number - i)
        .toFixed(places)
        .slice(2)
      : '') +
    symbol
  );
}

/*

将千分位转换成数字展示。

number：传入的千分位展示字符串。必选

thousand：千分位分隔符。必选

isSymbol：千分位展示字符串末尾的标识。可选，传入后，传入的千分位字符串长度减去isSymbol的长度

*/

export function toNumber(number, thousand = ',', isSymbol) {
  if (isSymbol) {
    var len = number.length - isSymbol.length;
    number = number.substring(0, number.len);
  }
  number = number.split(thousand).join('');
  return number;
}



/*

传递tenantId
如果没有tenantId，则通过域名取出对应的tentId

*/

export function getTenantId() {
  if (localStorage.getItem('tenantId')) {
    return localStorage.getItem('tenantId')
  } else {
    const hostname = window.location.hostname
    if (hostname.includes('tcqf')) {
      return 'tcqf'
    } else {
      return 'luttica'
    }
  }
}

// 金额转大写
export function dealBigMoney(money) {
  //最大处理的数字
  let maxNum = 999999999999999.9999;
  // 传入的参数为空情况
  if (money == '') {
    return '';
  }
  money = parseFloat(money);
  if (money >= maxNum) {
    return '';
  }
  //汉字的数字
  let cnNums = new Array('零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖');
  //基本单位
  let cnIntRadice = new Array('', '拾', '佰', '仟');
  //对应整数部分扩展单位
  let cnIntUnits = new Array('', '万', '亿', '兆');
  //对应小数部分单位
  let cnDecUnits = new Array('角', '分', '毫', '厘');
  //整数金额时后面跟的字符
  let cnInteger = '整';
  //整型完以后的单位
  let cnIntLast = '元';
  //金额整数部分
  let integerNum;
  //金额小数部分
  let decimalNum;
  //输出的中文金额字符串
  let chineseStr = '';
  //分离金额后用的数组，预定义
  let parts;
  // 传入的参数为0情况
  if(money == 0) {
    chineseStr = cnNums[0] + cnIntLast + cnInteger;
    return chineseStr;
  }
  // 转为字符串
  money = money.toString();
  // indexOf 检测某字符在字符串中首次出现的位置 返回索引值（从0 开始） -1 代表无
  if (money.indexOf('.') == -1) {
    integerNum = money;
    decimalNum = '';
  } else{
    parts = money.split('.');
    integerNum = parts[0];
    decimalNum = parts[1].substr(0,4);
  }
  //转换整数部分
  if (parseInt(integerNum,10) > 0) {
    let zeroCount = 0;
    let IntLen = integerNum.length;
    for (let i = 0; i < IntLen; i++) {
      let n = integerNum.substr(i,1);
      let p = IntLen - i - 1;
      let q = p / 4;
      let m = p % 4;
      if (n == '0') {
        zeroCount++ ;
      } else {
        if (zeroCount > 0) {
          chineseStr += cnNums[0];
        }
        zeroCount = 0;
        chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
      }
      if (m == 0 && zeroCount < 4) {
        chineseStr += cnIntUnits[q];
      }
    }
    // 最后+ 元
    chineseStr += cnIntLast;
  }
  // 转换小数部分
  if (decimalNum != '') {
    let decLen = decimalNum.length;
    for (let i = 0; i <decLen; i++) {
      let n = decimalNum.substr(i,1);
      if (n != '0') {
        chineseStr += cnNums[Number(n)] + cnDecUnits[i];
      }
    }
  }
  if (chineseStr == '') {
    chineseStr += cnNums[0] + cnIntLast + cnInteger;
  } else if (decimalNum == '') {
    chineseStr += cnInteger;
  }

  return chineseStr;
}

//字符串转Boolean
export function stringToBoolean(str) {
  if (typeof str !== 'string') {
    return false;
  }
  str = str.toLowerCase();
  return str === 'true' || !!'str';
}
